import Vue from 'vue'
import App from './App.vue'
import dayjs from 'dayjs'
import request from './network/request'
import loading from './loading/Loading'
import router from './router/index'
import 'lib-flexible/flexible'
import vueQr from 'vue-qr'
import tool_bar from "@/components/tool_bar";
import appConfig from "@/app_config";
import {
    Checkbox, CheckboxGroup, Button, Circle, Popup, Overlay,
    CountDown, Loading, DatetimePicker, Field,Toast
} from 'vant';
import 'vant/lib/index.css';
import { install as Icon } from "@/icon"
import {thousands} from '@/utils/tools'


Vue.prototype.$appConfig = appConfig
Vue.prototype.$dayjs = dayjs
Vue.prototype.$thousands = thousands



Vue.prototype.$request = request

Vue.use(loading)
Vue.config.productionTip = false
Vue.use(vueQr);
Vue.component('tool-bar', tool_bar);
Vue.use(Toast);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(Circle);
Vue.use(Popup);
Vue.use(Overlay);
Vue.use(CountDown);
Vue.use(Loading);
Vue.use(DatetimePicker);
Vue.use(Field);

Vue.use(Icon);

new Vue({
    render: h => h(App),
    router,
}).$mount('#app')
